const cities = [
  { text: 'option.municipality.001', value: 'Akaa' },
  { text: 'option.municipality.002', value: 'Alajärvi' },
  { text: 'option.municipality.003', value: 'Alavieska' },
  { text: 'option.municipality.004', value: 'Alavus' },
  { text: 'option.municipality.005', value: 'Asikkala' },
  { text: 'option.municipality.006', value: 'Askola' },
  { text: 'option.municipality.007', value: 'Aura' },
  { text: 'option.municipality.008', value: 'Brändö' },
  { text: 'option.municipality.009', value: 'Eckerö' },
  { text: 'option.municipality.010', value: 'Enonkoski' },
  { text: 'option.municipality.011', value: 'Enontekiö' },
  { text: 'option.municipality.012', value: 'Espoo' },
  { text: 'option.municipality.013', value: 'Eura' },
  { text: 'option.municipality.014', value: 'Eurajoki' },
  { text: 'option.municipality.015', value: 'Evijärvi' },
  { text: 'option.municipality.016', value: 'Finström' },
  { text: 'option.municipality.017', value: 'Forssa' },
  { text: 'option.municipality.018', value: 'Föglö' },
  { text: 'option.municipality.019', value: 'Geta' },
  { text: 'option.municipality.020', value: 'Haapajärvi' },
  { text: 'option.municipality.021', value: 'Haapavesi' },
  { text: 'option.municipality.022', value: 'Hailuoto' },
  { text: 'option.municipality.023', value: 'Halsua' },
  { text: 'option.municipality.024', value: 'Hamina' },
  { text: 'option.municipality.025', value: 'Hammarland' },
  { text: 'option.municipality.026', value: 'Hankasalmi' },
  { text: 'option.municipality.027', value: 'Hanko' },
  { text: 'option.municipality.028', value: 'Harjavalta' },
  { text: 'option.municipality.029', value: 'Hartola' },
  { text: 'option.municipality.030', value: 'Hattula' },
  { text: 'option.municipality.031', value: 'Hausjärvi' },
  { text: 'option.municipality.032', value: 'Heinävesi' },
  { text: 'option.municipality.033', value: 'Heinola' },
  { text: 'option.municipality.034', value: 'Helsinki' },
  { text: 'option.municipality.035', value: 'Hirvensalmi' },
  { text: 'option.municipality.036', value: 'Hollola' },
  { text: 'option.municipality.037', value: 'Huittinen' },
  { text: 'option.municipality.038', value: 'Humppila' },
  { text: 'option.municipality.039', value: 'Hyrynsalmi' },
  { text: 'option.municipality.040', value: 'Hyvinkää' },
  { text: 'option.municipality.041', value: 'Hämeenkyrö' },
  { text: 'option.municipality.042', value: 'Hämeenlinna' },
  { text: 'option.municipality.043', value: 'Ii' },
  { text: 'option.municipality.044', value: 'Iisalmi' },
  { text: 'option.municipality.045', value: 'Iitti' },
  { text: 'option.municipality.046', value: 'Ikaalinen' },
  { text: 'option.municipality.047', value: 'Ilmajoki' },
  { text: 'option.municipality.048', value: 'Ilomantsi' },
  { text: 'option.municipality.049', value: 'Imatra' },
  { text: 'option.municipality.050', value: 'Inari' },
  { text: 'option.municipality.051', value: 'Inkoo' },
  { text: 'option.municipality.052', value: 'Isojoki' },
  { text: 'option.municipality.053', value: 'Isokyrö' },
  { text: 'option.municipality.054', value: 'Janakkala' },
  { text: 'option.municipality.055', value: 'Joensuu' },
  { text: 'option.municipality.056', value: 'Jokioinen' },
  { text: 'option.municipality.057', value: 'Jomala' },
  { text: 'option.municipality.058', value: 'Joroinen' },
  { text: 'option.municipality.059', value: 'Joutsa' },
  { text: 'option.municipality.060', value: 'Juuka' },
  { text: 'option.municipality.061', value: 'Juupajoki' },
  { text: 'option.municipality.062', value: 'Juva' },
  { text: 'option.municipality.063', value: 'Jyväskylä' },
  { text: 'option.municipality.064', value: 'Jämijärvi' },
  { text: 'option.municipality.065', value: 'Jämsä' },
  { text: 'option.municipality.066', value: 'Järvenpää' },
  { text: 'option.municipality.067', value: 'Kaarina' },
  { text: 'option.municipality.068', value: 'Kaavi' },
  { text: 'option.municipality.069', value: 'Kajaani' },
  { text: 'option.municipality.070', value: 'Kalajoki' },
  { text: 'option.municipality.071', value: 'Kangasala' },
  { text: 'option.municipality.072', value: 'Kangasniemi' },
  { text: 'option.municipality.073', value: 'Kankaanpää' },
  { text: 'option.municipality.074', value: 'Kannonkoski' },
  { text: 'option.municipality.075', value: 'Kannus' },
  { text: 'option.municipality.076', value: 'Karijoki' },
  { text: 'option.municipality.077', value: 'Karkkila' },
  { text: 'option.municipality.078', value: 'Karstula' },
  { text: 'option.municipality.079', value: 'Karvia' },
  { text: 'option.municipality.080', value: 'Kaskinen' },
  { text: 'option.municipality.081', value: 'Kauhajoki' },
  { text: 'option.municipality.082', value: 'Kauhava' },
  { text: 'option.municipality.083', value: 'Kauniainen' },
  { text: 'option.municipality.084', value: 'Kaustinen' },
  { text: 'option.municipality.085', value: 'Keitele' },
  { text: 'option.municipality.086', value: 'Kemi' },
  { text: 'option.municipality.087', value: 'Kemijärvi' },
  { text: 'option.municipality.088', value: 'Kemiönsaari' },
  { text: 'option.municipality.089', value: 'Keminmaa' },
  { text: 'option.municipality.090', value: 'Kempele' },
  { text: 'option.municipality.091', value: 'Kerava' },
  { text: 'option.municipality.092', value: 'Kerimäki' },
  { text: 'option.municipality.093', value: 'Keuruu' },
  { text: 'option.municipality.094', value: 'Kihniö' },
  { text: 'option.municipality.095', value: 'Kinnula' },
  { text: 'option.municipality.096', value: 'Kirkkonummi' },
  { text: 'option.municipality.097', value: 'Kitee' },
  { text: 'option.municipality.098', value: 'Kittilä' },
  { text: 'option.municipality.099', value: 'Kiuruvesi' },
  { text: 'option.municipality.100', value: 'Kivijärvi' },
  { text: 'option.municipality.101', value: 'Kokemäki' },
  { text: 'option.municipality.102', value: 'Kokkola' },
  { text: 'option.municipality.103', value: 'Kolari' },
  { text: 'option.municipality.104', value: 'Konnevesi' },
  { text: 'option.municipality.105', value: 'Kontiolahti' },
  { text: 'option.municipality.106', value: 'Korsnäs' },
  { text: 'option.municipality.107', value: 'Koski Tl' },
  { text: 'option.municipality.108', value: 'Kotka' },
  { text: 'option.municipality.109', value: 'Kouvola' },
  { text: 'option.municipality.110', value: 'Kristiinankaupunki' },
  { text: 'option.municipality.111', value: 'Kruunupyy' },
  { text: 'option.municipality.112', value: 'Kuhmo' },
  { text: 'option.municipality.113', value: 'Kuhmoinen' },
  { text: 'option.municipality.114', value: 'Kumlinge' },
  { text: 'option.municipality.115', value: 'Kuopio' },
  { text: 'option.municipality.116', value: 'Kuortane' },
  { text: 'option.municipality.117', value: 'Kurikka' },
  { text: 'option.municipality.118', value: 'Kustavi' },
  { text: 'option.municipality.119', value: 'Kuusamo' },
  { text: 'option.municipality.120', value: 'Kyyjärvi' },
  { text: 'option.municipality.121', value: 'Kärkölä' },
  { text: 'option.municipality.122', value: 'Kärsämäki' },
  { text: 'option.municipality.123', value: 'Kökar' },
  { text: 'option.municipality.124', value: 'Lahti' },
  { text: 'option.municipality.125', value: 'Laihia' },
  { text: 'option.municipality.126', value: 'Laitila' },
  { text: 'option.municipality.127', value: 'Lapinjärvi' },
  { text: 'option.municipality.128', value: 'Lapinlahti' },
  { text: 'option.municipality.129', value: 'Lappajärvi' },
  { text: 'option.municipality.130', value: 'Lappeenranta' },
  { text: 'option.municipality.131', value: 'Lapua' },
  { text: 'option.municipality.132', value: 'Laukaa' },
  { text: 'option.municipality.133', value: 'Lemi' },
  { text: 'option.municipality.134', value: 'Lemland' },
  { text: 'option.municipality.135', value: 'Lempäälä' },
  { text: 'option.municipality.136', value: 'Leppävirta' },
  { text: 'option.municipality.137', value: 'Lestijärvi' },
  { text: 'option.municipality.138', value: 'Lieksa' },
  { text: 'option.municipality.139', value: 'Lieto' },
  { text: 'option.municipality.140', value: 'Liminka' },
  { text: 'option.municipality.141', value: 'Liperi' },
  { text: 'option.municipality.142', value: 'Lohja' },
  { text: 'option.municipality.143', value: 'Loimaa' },
  { text: 'option.municipality.144', value: 'Loppi' },
  { text: 'option.municipality.145', value: 'Loviisa' },
  { text: 'option.municipality.146', value: 'Luhanka' },
  { text: 'option.municipality.147', value: 'Lumijoki' },
  { text: 'option.municipality.148', value: 'Lumparland' },
  { text: 'option.municipality.149', value: 'Luoto' },
  { text: 'option.municipality.150', value: 'Luumäki' },
  { text: 'option.municipality.151', value: 'Maalahti' },
  { text: 'option.municipality.152', value: 'Maarianhamina' },
  { text: 'option.municipality.153', value: 'Marttila' },
  { text: 'option.municipality.154', value: 'Masku' },
  { text: 'option.municipality.155', value: 'Merijärvi' },
  { text: 'option.municipality.156', value: 'Merikarvia' },
  { text: 'option.municipality.157', value: 'Miehikkälä' },
  { text: 'option.municipality.158', value: 'Mikkeli' },
  { text: 'option.municipality.159', value: 'Muhos' },
  { text: 'option.municipality.160', value: 'Multia' },
  { text: 'option.municipality.161', value: 'Muonio' },
  { text: 'option.municipality.162', value: 'Mustasaari' },
  { text: 'option.municipality.163', value: 'Muurame' },
  { text: 'option.municipality.164', value: 'Mynämäki' },
  { text: 'option.municipality.165', value: 'Myrskylä' },
  { text: 'option.municipality.166', value: 'Mäntsälä' },
  { text: 'option.municipality.167', value: 'Mänttä-Vilppula' },
  { text: 'option.municipality.168', value: 'Mäntyharju' },
  { text: 'option.municipality.169', value: 'Naantali' },
  { text: 'option.municipality.170', value: 'Nakkila' },
  { text: 'option.municipality.171', value: 'Nivala' },
  { text: 'option.municipality.172', value: 'Nokia' },
  { text: 'option.municipality.173', value: 'Nousiainen' },
  { text: 'option.municipality.174', value: 'Nurmes' },
  { text: 'option.municipality.175', value: 'Nurmijärvi' },
  { text: 'option.municipality.176', value: 'Närpiö' },
  { text: 'option.municipality.177', value: 'Orimattila' },
  { text: 'option.municipality.178', value: 'Oripää' },
  { text: 'option.municipality.179', value: 'Orivesi' },
  { text: 'option.municipality.180', value: 'Oulainen' },
  { text: 'option.municipality.181', value: 'Oulu' },
  { text: 'option.municipality.182', value: 'Outokumpu' },
  { text: 'option.municipality.183', value: 'Padasjoki' },
  { text: 'option.municipality.184', value: 'Paimio' },
  { text: 'option.municipality.185', value: 'Paltamo' },
  { text: 'option.municipality.186', value: 'Parainen' },
  { text: 'option.municipality.187', value: 'Parikkala' },
  { text: 'option.municipality.188', value: 'Parkano' },
  { text: 'option.municipality.189', value: 'Pedersören Kunta' },
  { text: 'option.municipality.190', value: 'Pelkosenniemi' },
  { text: 'option.municipality.191', value: 'Pello' },
  { text: 'option.municipality.192', value: 'Perho' },
  { text: 'option.municipality.193', value: 'Pertunmaa' },
  { text: 'option.municipality.194', value: 'Petäjävesi' },
  { text: 'option.municipality.195', value: 'Pieksämäki' },
  { text: 'option.municipality.196', value: 'Pielavesi' },
  { text: 'option.municipality.197', value: 'Pietarsaaren Mlk' },
  { text: 'option.municipality.198', value: 'Pietarsaari' },
  { text: 'option.municipality.199', value: 'Pihtipudas' },
  { text: 'option.municipality.200', value: 'Pirkkala' },
  { text: 'option.municipality.201', value: 'Polvijärvi' },
  { text: 'option.municipality.202', value: 'Pomarkku' },
  { text: 'option.municipality.203', value: 'Pori' },
  { text: 'option.municipality.204', value: 'Pornainen' },
  { text: 'option.municipality.205', value: 'Porvoo' },
  { text: 'option.municipality.206', value: 'Posio' },
  { text: 'option.municipality.207', value: 'Pudasjärvi' },
  { text: 'option.municipality.208', value: 'Pukkila' },
  { text: 'option.municipality.209', value: 'Punkaharju' },
  { text: 'option.municipality.210', value: 'Punkalaidun' },
  { text: 'option.municipality.211', value: 'Puolanka' },
  { text: 'option.municipality.212', value: 'Puumala' },
  { text: 'option.municipality.213', value: 'Pyhäjoki' },
  { text: 'option.municipality.214', value: 'Pyhäjärvi' },
  { text: 'option.municipality.215', value: 'Pyhäntä' },
  { text: 'option.municipality.216', value: 'Pyhäranta' },
  { text: 'option.municipality.217', value: 'Pyhtää' },
  { text: 'option.municipality.218', value: 'Pälkäne' },
  { text: 'option.municipality.219', value: 'Pöytyä' },
  { text: 'option.municipality.220', value: 'Raahe' },
  { text: 'option.municipality.221', value: 'Raasepori' },
  { text: 'option.municipality.222', value: 'Raisio' },
  { text: 'option.municipality.223', value: 'Rantasalmi' },
  { text: 'option.municipality.224', value: 'Ranua' },
  { text: 'option.municipality.225', value: 'Rauma' },
  { text: 'option.municipality.226', value: 'Rautalampi' },
  { text: 'option.municipality.227', value: 'Rautavaara' },
  { text: 'option.municipality.228', value: 'Rautjärvi' },
  { text: 'option.municipality.229', value: 'Reisjärvi' },
  { text: 'option.municipality.230', value: 'Riihimäki' },
  { text: 'option.municipality.231', value: 'Ristijärvi' },
  { text: 'option.municipality.232', value: 'Rovaniemi' },
  { text: 'option.municipality.233', value: 'Ruokolahti' },
  { text: 'option.municipality.234', value: 'Ruovesi' },
  { text: 'option.municipality.235', value: 'Rusko' },
  { text: 'option.municipality.236', value: 'Rääkkylä' },
  { text: 'option.municipality.237', value: 'Saarijärvi' },
  { text: 'option.municipality.238', value: 'Salla' },
  { text: 'option.municipality.239', value: 'Salo' },
  { text: 'option.municipality.240', value: 'Saltvik' },
  { text: 'option.municipality.241', value: 'Sastamala' },
  { text: 'option.municipality.242', value: 'Sauvo' },
  { text: 'option.municipality.243', value: 'Savitaipale' },
  { text: 'option.municipality.244', value: 'Savonlinna' },
  { text: 'option.municipality.245', value: 'Savukoski' },
  { text: 'option.municipality.246', value: 'Seinäjoki' },
  { text: 'option.municipality.247', value: 'Sievi' },
  { text: 'option.municipality.248', value: 'Siikainen' },
  { text: 'option.municipality.249', value: 'Siikajoki' },
  { text: 'option.municipality.250', value: 'Siikalatva' },
  { text: 'option.municipality.251', value: 'Siilinjärvi' },
  { text: 'option.municipality.252', value: 'Simo' },
  { text: 'option.municipality.253', value: 'Sipoo' },
  { text: 'option.municipality.254', value: 'Siuntio' },
  { text: 'option.municipality.255', value: 'Sodankylä' },
  { text: 'option.municipality.256', value: 'Soini' },
  { text: 'option.municipality.257', value: 'Somero' },
  { text: 'option.municipality.258', value: 'Sonkajärvi' },
  { text: 'option.municipality.259', value: 'Sotkamo' },
  { text: 'option.municipality.260', value: 'Sottunga' },
  { text: 'option.municipality.261', value: 'Sulkava' },
  { text: 'option.municipality.262', value: 'Sund' },
  { text: 'option.municipality.263', value: 'Suomussalmi' },
  { text: 'option.municipality.264', value: 'Suonenjoki' },
  { text: 'option.municipality.265', value: 'Sysmä' },
  { text: 'option.municipality.266', value: 'Säkylä' },
  { text: 'option.municipality.267', value: 'Taipalsaari' },
  { text: 'option.municipality.268', value: 'Taivalkoski' },
  { text: 'option.municipality.269', value: 'Taivassalo' },
  { text: 'option.municipality.270', value: 'Tammela' },
  { text: 'option.municipality.271', value: 'Tampere' },
  { text: 'option.municipality.272', value: 'Tervo' },
  { text: 'option.municipality.273', value: 'Tervola' },
  { text: 'option.municipality.274', value: 'Teuva' },
  { text: 'option.municipality.275', value: 'Tohmajärvi' },
  { text: 'option.municipality.276', value: 'Toholampi' },
  { text: 'option.municipality.277', value: 'Toivakka' },
  { text: 'option.municipality.278', value: 'Tornio' },
  { text: 'option.municipality.279', value: 'Turku' },
  { text: 'option.municipality.280', value: 'Tuusniemi' },
  { text: 'option.municipality.281', value: 'Tuusula' },
  { text: 'option.municipality.282', value: 'Tyrnävä' },
  { text: 'option.municipality.283', value: 'Ulvila' },
  { text: 'option.municipality.284', value: 'Urjala' },
  { text: 'option.municipality.285', value: 'Utajärvi' },
  { text: 'option.municipality.286', value: 'Utsjoki' },
  { text: 'option.municipality.287', value: 'Uurainen' },
  { text: 'option.municipality.288', value: 'Uusikaarlepyy' },
  { text: 'option.municipality.289', value: 'Uusikaupunki' },
  { text: 'option.municipality.290', value: 'Vaala' },
  { text: 'option.municipality.291', value: 'Vaasa' },
  { text: 'option.municipality.292', value: 'Valkeakoski' },
  { text: 'option.municipality.293', value: 'Vantaa' },
  { text: 'option.municipality.294', value: 'Varkaus' },
  { text: 'option.municipality.295', value: 'Vehmaa' },
  { text: 'option.municipality.296', value: 'Vesanto' },
  { text: 'option.municipality.297', value: 'Vesilahti' },
  { text: 'option.municipality.298', value: 'Veteli' },
  { text: 'option.municipality.299', value: 'Vieremä' },
  { text: 'option.municipality.300', value: 'Vihti' },
  { text: 'option.municipality.301', value: 'Viitasaari' },
  { text: 'option.municipality.302', value: 'Vimpeli' },
  { text: 'option.municipality.303', value: 'Virolahti' },
  { text: 'option.municipality.304', value: 'Virrat' },
  { text: 'option.municipality.305', value: 'Vårdö' },
  { text: 'option.municipality.306', value: 'Vöyri' },
  { text: 'option.municipality.307', value: 'Ylöjärvi' },
  { text: 'option.municipality.308', value: 'Ylitornio' },
  { text: 'option.municipality.309', value: 'Ylivieska' },
  { text: 'option.municipality.310', value: 'Ypäjä' },
  { text: 'option.municipality.311', value: 'Ähtäri' },
  { text: 'option.municipality.312', value: 'Äänekoski' },
];

export default cities;
